module.exports = __webpack_public_path__ + "img/symbol_10.f00af64b.png";